function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M542.117647 0c15.329882 0 29.846588 6.746353 39.664941 18.371765l228.442353 271.420235 193.746824-127.879529a52.073412 52.073412 0 0 1 57.705411 0.301176c17.377882 11.715765 25.840941 32.707765 21.38353 53.067294l-129.084235 587.745883A51.501176 51.501176 0 0 1 903.529412 843.294118H180.705882a51.501176 51.501176 0 0 1-50.447058-40.267294L1.174588 215.280941a50.868706 50.868706 0 0 1 21.38353-53.067294 52.073412 52.073412 0 0 1 57.705411-0.301176l193.746824 127.879529L502.452706 18.371765C512.301176 6.746353 526.787765 0 542.117647 0zM120.470588 973.793882c0-27.708235 23.612235-50.176 52.705883-50.176h737.882353c18.823529 0 36.231529 9.547294 45.658352 25.088a48.128 48.128 0 0 1 0 50.206118c-9.426824 15.510588-26.804706 25.088-45.658352 25.088H173.176471C144.082824 1024 120.470588 1001.532235 120.470588 973.793882z m342.588236-351.35247c0 27.708235 23.612235 50.176 52.705882 50.176h52.705882c29.093647 0 52.705882-22.467765 52.705883-50.176 0-27.708235-23.612235-50.206118-52.705883-50.206118h-52.705882c-29.093647 0-52.705882 22.467765-52.705882 50.206118z",
  "p-id": 21622,
  fill: "#0079fe"
});

var SvgCrown = function SvgCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1594434611882,
    className: "icon",
    viewBox: "0 0 1084 1024",
    "p-id": 21621,
    width: 29.640625,
    height: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crown.5e5d485b.svg";
export { ForwardRef as ReactComponent };